var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11902_113187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.25323 12.2003C1.91123 12.2003 0.813232 11.1023 0.813232 9.76029V4.06695C0.813232 2.72495 1.91123 1.62695 3.25323 1.62695H6.91323C7.15723 1.62695 7.3199 1.78962 7.3199 2.03362C7.3199 2.27762 7.15723 2.44029 6.91323 2.44029H3.25323C2.35857 2.44029 1.62657 3.17229 1.62657 4.06695V9.76029C1.62657 10.655 2.35857 11.387 3.25323 11.387H8.94657C9.84123 11.387 10.5732 10.655 10.5732 9.76029V5.69362C10.5732 5.44962 10.7359 5.28695 10.9799 5.28695C11.2239 5.28695 11.3866 5.44962 11.3866 5.69362V9.76029C11.3866 11.1023 10.2886 12.2003 8.94657 12.2003H3.25323Z",
    fill: "#3b3e45"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03243 5.98092C6.87362 5.8221 6.87362 5.56462 7.03243 5.4058L11.9124 0.525803C12.0712 0.36699 12.3287 0.36699 12.4875 0.525803C12.6464 0.684616 12.6464 0.942103 12.4875 1.10092L7.60754 5.98092C7.44873 6.13973 7.19124 6.13973 7.03243 5.98092Z",
    fill: "#3b3e45"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54009 0.406919L12.2001 0.406919C12.4247 0.406918 12.6068 0.588989 12.6068 0.813585V4.47359C12.6068 4.69818 12.4247 4.88025 12.2001 4.88025C11.9755 4.88025 11.7934 4.69818 11.7934 4.47358L11.7934 1.79537L8.42098 5.16781L7.84587 4.5927L11.2183 1.22025L8.54009 1.22025C8.3155 1.22025 8.13343 1.03818 8.13343 0.813585C8.13343 0.588989 8.3155 0.406919 8.54009 0.406919Z",
    fill: "#3b3e45"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11902_113187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.0133,
    height: 13.0133,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkGrey);
export default __webpack_public_path__ + "static/media/link_grey.f1762713a49de2c92016d0d3debae79e.svg";
export { ForwardRef as ReactComponent };